export default __webpack_public_path__ + "static/media/shower-dark.38cfa185.svg";